import * as React from 'react';
import ConfirmationPopup from 'components/Popup/Confirmation';

const styles = require('./styles.pcss');

type Props = {
  open: boolean;
  onClose: () => void;
  onSubmit: () => void;
  pnr: string;
  bookingPrice: number;
};

const RedeemCRCPointsPopup = (props: Props) => {
  const pointsToRedeem = props.bookingPrice * 100;
  return (
    <ConfirmationPopup
      open={props.open}
      onClose={props.onClose}
      onSubmit={props.onSubmit}
      title="Redeem CRC Points"
      bodyText={
        <div>
          <p>{`Confirm the CRC reward points redemption for booking ${props.pnr}.`}</p>
          <div className={styles.crcRedeemRow}>
            <span>Booking price</span>
            <span>${props.bookingPrice.toFixed(2)}</span>
          </div>
          <div className={styles.crcRedeemDivider} />
          <div className={styles.crcRedeemRow}>
            <span>Points to Redeem</span>
            <span>{pointsToRedeem.toLocaleString()} pts</span>
          </div>
        </div>
      }
      submitButtonText="Confirm redemption"
      closeButtonText="Cancel"
    />
  );
};

export default RedeemCRCPointsPopup;
